import { __decorate, __metadata } from 'tslib';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiCButtonModule } from '@wlp/ui-c-button';
import { UiCInputModule } from '@wlp/ui-c-input';

let UiCCompanyDataComponent = class UiCCompanyDataComponent {
    constructor() {
        this.onChange = new EventEmitter();
        this.onMask = new EventEmitter();
        this.finish = new EventEmitter();
    }
    ngOnInit() { }
    onChangeForm() {
        this.onChange.emit(this.companyDataForm);
    }
    checkValue(value) {
        if (value === '0' || /^0/.test(value)) {
            this.companyDataForm.controls.turnoverAverage.setValue(null);
        }
    }
    goContinue() {
        this.finish.emit(this.companyDataForm);
    }
};
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCCompanyDataComponent.prototype, "companyDataForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCCompanyDataComponent.prototype, "errorMessages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCCompanyDataComponent.prototype, "isMEI", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCompanyDataComponent.prototype, "onChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCCompanyDataComponent.prototype, "onMask", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], UiCCompanyDataComponent.prototype, "finish", void 0);
UiCCompanyDataComponent = __decorate([
    Component({
        selector: 'ui-c-company-data',
        template: "<div id=\"form-controller\">\n  <ion-row class=\"ion-justify-content-left ion-align-items-center\">\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input data-cy=\"onboarding-pj-companyname\" [errorMessages]=\"errorMessages\" [form]=\"companyDataForm\"\n        [formName]=\"'companyName'\" [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.CORPORATE_NAME' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.CORPORATE_NAME' | wlpTranslate\">\n      </ui-c-input>\n    </ion-col>\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input data-cy=\"onboarding-pj-establishmentdate\" [errorMessages]=\"errorMessages\" [form]=\"companyDataForm\"\n        [formName]=\"'establishmentDate'\" [isDate]=\"true\"\n        [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.DATE' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.DATE_OF_ESTABLISHMENT' | wlpTranslate\">\n      </ui-c-input>\n    </ion-col>\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input data-cy=\"onboarding-pj-cnaeCode\" [errorMessages]=\"errorMessages\" [form]=\"companyDataForm\"\n        [formName]=\"'cnaeCode'\" [isNumber]=\"true\"\n        [placeholder]=\"\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.CNAE_CODE' | wlpTranslate\">\n      </ui-c-input>\n    </ion-col>\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input data-cy=\"onboarding-pj-cnaeDescription\" [errorMessages]=\"errorMessages\" [form]=\"companyDataForm\"\n        [formName]=\"'cnaeDescription'\"\n        [placeholder]=\"'Descri\u00E7\u00E3o do cnae'\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.CNAE_DESCRIPTION' | wlpTranslate\">\n      </ui-c-input>\n    </ion-col>\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\" *ngIf=\"!isMEI\">\n      <ui-c-input data-cy=\"onboarding-pj-manyperson\" [errorMessages]=\"errorMessages\" [form]=\"companyDataForm\"\n        [formName]=\"'manyPerson'\" [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.MANY_PERSON' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.MANY_PERSON' | wlpTranslate\" [isNumber]=\"true\" [maxlength]=\"3\">\n      </ui-c-input>\n    </ion-col>\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input data-cy=\"onboarding-pj-turnoveraverage\" [errorMessages]=\"errorMessages\" [form]=\"companyDataForm\"\n        [formName]=\"'turnoverAverage'\" [isMoney]=\"true\"\n        [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.MONEY' | wlpTranslate\"\n        [name]=\"'ONBORDING.V2.FORM.LABEL.TURNOVER_AVERAGE' | wlpTranslate\">\n      </ui-c-input>\n    </ion-col>\n    <ion-col [size]=\"12\" [sizeMd]=\"8\" [sizeSm]=\"8\">\n      <ui-c-input data-cy=\"onboarding-pj-phone\" [errorMessages]=\"errorMessages\" [form]=\"companyDataForm\"\n        [formName]=\"'phone'\" [name]=\"'ONBORDING.V2.FORM.LABEL.PHONE' | wlpTranslate\"\n        [placeholder]=\"'ONBORDING.V2.FORM.PLACEHOLDER.PHONE' | wlpTranslate\" [isPhone]=\"true\" [maxlength]=\"15\">\n      </ui-c-input>\n    </ion-col>\n  </ion-row>\n\n  <ion-row class=\"ion-justify-content-left ion-margin-top ion-margin-bottom\">\n    <ion-col [size]=\"12\" [sizeMd]=\"4\" [sizeSm]=\"4\">\n      <ui-c-button data-cy=\"onboarding-companydata-btn\" expand=\"block\" [disabled]=\"companyDataForm.invalid\"\n        (click)=\"goContinue()\">\n        {{ 'ONBORDING.V2.BUTTON.NEXT' | wlpTranslate }}\n      </ui-c-button>\n    </ion-col>\n  </ion-row>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCCompanyDataComponent);

let UiCCompanyDataModule = class UiCCompanyDataModule {
};
UiCCompanyDataModule = __decorate([
    NgModule({
        declarations: [UiCCompanyDataComponent],
        imports: [
            IonicModule,
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            UiCInputModule,
            UiCButtonModule,
            UiBsTranslateModule
        ],
        exports: [UiCCompanyDataComponent],
    })
], UiCCompanyDataModule);

export { UiCCompanyDataComponent, UiCCompanyDataModule };
//# sourceMappingURL=wlp-ui-c-company-data.js.map
